import mapLayer from '../../../../../../assets/image/surface_maps_get_started.png';
import { FeatureFigure } from './FeatureFigure';

export function MapLayersSection() {
  return (
    <>
      <h2>Map Layers</h2>
      {/* TODO: ADD LINKS TO SPANS? */}
      <p>
        The map features customizable layers such as
        <a href="#shapeFileUpload"> shape file upload </a> and
        <a href="#surfaceMaps"> surface maps </a>.
      </p>
      <h3 id="shapeFileUpload"> Shape file upload </h3>
      <p>
        Upload custom shape files to display e.g., your project area or points of interest on the
        map. Multiple shape files may be added freely.
      </p>
      <h3 id="surfaceMaps">Surface maps</h3>
      <p>
        Surface maps are zoomable 2D layers of various variables. The color legend automatically
        adjusts to the content of the map window. All datasets have water depth as a surface map,
        while some datasets have also other maps, such as e.g., mean H<sub>m0</sub>.
      </p>
      <FeatureFigure
        src={mapLayer}
        caption={`Surface map "Water depth" of the North Europe dataset, overlain by shape file "OWF"s - Europe' (orange lines).`}
      />
    </>
  );
}
